import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Popup } from '../../../Global/Popup';
import { base_url } from '../../../Api/Api';
import { Loader } from '../../../Global/Loader';

import Header from '../../../Global/Header';

const EditShopInfo = (props) => {

    const [state, setState] = useState({
        provinces: [],
        cities: [],
        loader: true,
        toggleAnim: true,
        dropdownClass: false,
        statusBottomSheet: false,
        selectedProvince: '',
        selectedProvinceId: ''
    })

    useEffect(() => {


        base_url.get(`getProvinces`)
            .then(response => {
                console.log(response.data)
                setState({
                    ...state,
                    provinces: response.data.provinces,
                    loader: false,
                    toggleAnim: false,
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })

    }, [])

    // toggle bottom sheet
    const closeBottomSheet = (isOpen) => {
        setState({
            ...state,
            statusBottomSheet: !state.statusBottomSheet,
            dropdownClass: state.selectedProvince.length == 0 ? !state.statusBottomSheet : true
        })
    }

    const handleChange = (event) => {
        setState({
            ...state,
            selectedProvince: event.target.name,
            selectedProvinceId: parseInt(event.target.value),
            statusBottomSheet: false
        })
    };

    const submitShopEdit = () => {

    }

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <div className={`instructpg edit-shopinfo ${state.toggleAnim ? '' : 'active'}`}>
                <Header
                    innerPage={true}
                    title={`تغییر اطلاعات فروشگاه`} />

                <div className="body-editshop">

                    <div
                        className="input-form"
                        onClick={closeBottomSheet} >
                        <div className={`dropdown-customs ${state.dropdownClass ? 'active' : ''}`}>
                            <span>استان</span>
                            <strong>{state.selectedProvince}</strong>
                            <i className="icon-arrow-down-sign-to-navigate-fill"></i>
                        </div>
                        <span className={`error-respns ${state.selectedProvince.length == 0 && state.validInput ? 'active' : ''}`}>
                            <i className="icon-exclamation-mark"></i>
                                موضوع پیام خود را انتخاب کنید
                        </span>
                    </div>

                    <div
                        className="input-form"
                        onClick={closeBottomSheet} >
                        <div className={`dropdown-customs ${state.dropdownClass ? 'active' : ''}`}>
                            <span>شهر</span>
                            <strong>{state.selectedProvince}</strong>
                            <i className="icon-arrow-down-sign-to-navigate-fill"></i>
                        </div>
                        <span className={`error-respns ${state.selectedProvince.length == 0 && state.validInput ? 'active' : ''}`}>
                            <i className="icon-exclamation-mark"></i>
                                موضوع پیام خود را انتخاب کنید
                        </span>
                    </div>
                    <div
                        className="input-form"
                        onClick={closeBottomSheet} >
                        <div className={`dropdown-customs ${state.dropdownClass ? 'active' : ''}`}>
                            <span>نام فروشگاه</span>
                            <strong>{state.selectedProvince}</strong>
                            <i className="icon-arrow-down-sign-to-navigate-fill"></i>
                        </div>
                        <span className={`error-respns ${state.selectedProvince.length == 0 && state.validInput ? 'active' : ''}`}>
                            <i className="icon-exclamation-mark"></i>
                                موضوع پیام خود را انتخاب کنید
                        </span>
                    </div>

                </div>
                <div className="btn-base btn-black btn-sircle">
                    <Button
                        variant="contained"
                        onClick={submitShopEdit} >ارسال</Button>
                </div>

                <div className="btm-sht">
                    <SwipeableBottomSheet
                        open={state.statusBottomSheet}
                        onChange={(e) => closeBottomSheet(e)}
                        overflowHeight={0}>
                        <div
                            style={{ height: 'auto' }}
                            className="bottom-sheet">
                            {state.provinces.length == 0 ? null :
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">استان</FormLabel>
                                    <div className="overflow-cntrl">
                                        <RadioGroup aria-label="subject" name="subject" value={state.selectedProvinceId} onChange={handleChange}>
                                            {state.provinces.map(item =>
                                                <FormControlLabel
                                                    key={item.id}
                                                    value={item.id}
                                                    name={item.name}
                                                    control={<Radio key={item.id} />}
                                                    label={item.name} />
                                            )}
                                        </RadioGroup>
                                    </div>
                                </FormControl>
                            }
                        </div>
                    </SwipeableBottomSheet>
                </div>

            </div>
        </React.Fragment>
    );
}

export default EditShopInfo;